import CopyAllIcon from "@mui/icons-material/CopyAllRounded";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineRounded";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHorizRounded";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { IconButton, Menu } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import ActionMenuItem from "@entrilia/shared/components/ActionMenuItem";
import DuplicateReportIcon from "@entrilia/shared/icons/DuplicateReportIcon";
interface Props {
  dashboardId: string;
  onDelete: (dashboardId: string) => void;
  onDuplicate: (dashboardId: string) => void;
  onCopy: (dashboardId: string) => void;
}

const DashboardActions = ({ dashboardId, onDelete, onDuplicate, onCopy }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const navigate = useNavigate();

  const onClose = () => setAnchorEl(null);

  const handleDeleteReport = () => {
    onDelete(dashboardId);
    onClose();
  };

  const handleDuplicateReport = () => {
    onDuplicate(dashboardId);
    onClose();
  };

  const handleShareReport = () => {};

  const handleCopyToDashboard = () => {
    onCopy(dashboardId);
    onClose();
  };

  const handleEditDashboard = () => {
    navigate(`./${dashboardId}/edit`);
  };

  return (
    <>
      <IconButton
        onClick={(evt) => {
          setAnchorEl(evt.currentTarget);
        }}
      >
        <MoreHorizIcon />
      </IconButton>
      <>
        <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={onClose} slotProps={{ paper: { sx: { minWidth: 200 } } }}>
          <ActionMenuItem key={"edit"} icon={<EditOutlinedIcon />} title="Edit" onClick={handleEditDashboard} />
          <ActionMenuItem key={"copy-to"} icon={<CopyAllIcon />} title="Copy to..." onClick={handleCopyToDashboard} />
          <ActionMenuItem
            key={"duplicate"}
            icon={<DuplicateReportIcon />}
            title="Duplicate"
            onClick={handleDuplicateReport}
          />
          <ActionMenuItem
            key={"share"}
            icon={<ShareOutlinedIcon />}
            title="Share"
            onClick={handleShareReport}
            disabled
          />
          <ActionMenuItem
            key={"delete"}
            icon={<DeleteOutlineIcon color="error" />}
            title="Delete"
            onClick={handleDeleteReport}
          />
        </Menu>
      </>
    </>
  );
};

export default DashboardActions;
